export const systemTenants: string[] = [
  'provider tenant',
  'test tenant',
  'synthetics tenant',
  'system tenant'
]
